<template>
    <div class="workordrAssign xglx">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>修改事件工单类型
        </div>
        <div class="workordr_content">
            <el-form label-width="146px"
                     :model="ruleForm"
                     label-position="left"
                     ref="ruleFormRef"
            >

                <div style="background-color: white;padding:12px;">
                    <el-form-item label="工单类型">
                        <el-select v-model="ruleForm.czCzjgzt" placeholder="请选择">
                            <el-option v-for="item in gdlxSelect" :label="item.label" :value="item.value" :disabled="item.disabled"/>
                        </el-select>
                    </el-form-item>
                    <p class="dqgdlx"><i class="icon-icon_tip"></i>当前工单类型 - {{dqgdlxText}} </p>
                </div>

                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, watch} from 'vue';
    import {useStore} from 'vuex';
    import {ElMessageBox, ElLoading} from 'element-plus'

    export default {
        name: "WorkorderGDGP",
        props: ["gdId", "timeCzJz"],
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleForm = reactive({
                "czCzlx": "XGLX",
                "gdId": props.gdId,
                "czCzjgzt":""
            });
            const ruleFormRef = ref()

            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if (action == "confirm") {
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent","xgxl");
                                        store.state.addNewWorkorderSuccess = true;
                                        loading.close()
                                    }).catch(e => {
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            let gdlxSelect = ref()
            let dqgdlxText = ref()
            onMounted(() => {
                proxy.$axios.post("/jgfast/wgsj/getCodeTable", {
                    "codeTable": "cdg_wgsj_gdlx"
                }).then((res) => {
                    gdlxSelect.value = res.data.cdg_wgsj_gdlx
                }).then(()=>{
                    proxy.$axios.post("/jgfast/wgsj/selGdlx", {
                        "gdId": props.gdId,
                    }).then((res) => {
                        dqgdlxText.value = res.data.gdGdlxDic
                        gdlxSelect.value.map(item =>{
                            if(item.value == res.data.gdGdlx){
                                item.disabled = true
                            }else{
                                ruleForm.czCzjgzt = item.value
                            }
                        })
                    });
                });

            })
            //取消事件
            const cancleClick = () => {
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if (action == "confirm") {
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            return {
                ruleFormRef,
                ruleForm,
                submitForm,
                cancleClick,
                gdlxSelect,
                dqgdlxText
            }
        }
    }
</script>

<style scoped lang="less">
    .workordrAssign.xglx {
        .el-form-item {
            margin: 0;
        }
        .dqgdlx{
            padding-left:12px;
            height: 36px;
            display: flex;
            align-items: center;
            color: #5c5fcc;
            .icon-icon_tip::before{
                color: #5c5fcc;
                font-size: 16px;
                margin-right:8px;
            }
        }
    }
</style>
